import { createReducer } from '@src/redux/helpers/createReducer';

import { SET_RELOAD_POPUP } from './constants';

const initialState = {
  reloadPopup: true,
};

export const reloadPopupReducer = createReducer(initialState, {
  [SET_RELOAD_POPUP]: (state, action) => {
    return {
      ...state,
      reloadPopup: action.payload,
    };
  },
});
